import { render } from "./ApiTest.vue?vue&type=template&id=c5cdeaa6&scoped=true"
import script from "./ApiTest.vue?vue&type=script&lang=js"
export * from "./ApiTest.vue?vue&type=script&lang=js"

import "./ApiTest.vue?vue&type=style&index=0&id=c5cdeaa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5cdeaa6"]])

export default __exports__